//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
//@end

//@import components
import EventItemSkeleton from 'app_components/screens/landing/eventitem/components/eventItemSkeleton';
import {PublicAppLayout} from 'app_components/layouts/public'
import BannerTextPrimaryCommon from 'app_components/commons/bannertextprimary'
import ContentNewsCommon from 'app_components/commons/contentnews'
import SeparatorHorCommon from 'app_components/commons/separatorhor'
import AlertComponent from 'app_components/commons/alert/containers/alertComponent';
//@end

// @import hooks
// @end

// @INFO Import types
import { IPost } from 'app_types/campus/postTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../eventitemScreen.scss'

// @ADD Component types
interface IEventitemScreenLayoutProps {
  post: IPost | null
  loading_post: boolean
}

const EventitemScreenLayout: React.FC<IEventitemScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <PublicAppLayout>

      <div className={'event-item-s'}>
        <BannerTextPrimaryCommon text={'Eventos'}/>
        <div>
          {props.loading_post ? (
            <EventItemSkeleton />
          ) : (
            <>
              {props.post ? (
                <ContentNewsCommon news={props.post}/>
              ) : (
                <div className="mt-3">
                  <AlertComponent
                    type='warning'
                    title={t('screens.events.no_data')}
                  />
                </div>
              )}
            </>
          )}
        </div>
          <SeparatorHorCommon/>
      </div>
    </PublicAppLayout>
  )
}

export default EventitemScreenLayout
